/*! Mega menu - columns + hover image (custom block). Additive, does not modify theme.js */
(function () {
  if (customElements.get('mega-menu-columns')) return;

  class MegaMenuColumns extends HTMLElement {
    connectedCallback() {
      this.panel = this.closest('.mega-menu__list')?.querySelector('[data-mega-panel]');
      if (!this.panel) return;

      this.caption = this.panel.querySelector('[data-mega-caption]');
      this.ctas = Array.from(this.panel.querySelectorAll('[data-mega-link]'));
      this.follow = this.panel.hasAttribute('data-follow');

      this.querySelectorAll('a[data-mega-key]').forEach((link) => {
        link.addEventListener('mouseenter', () => this.activate(link));
        link.addEventListener('focus', () => this.activate(link));
      });
    }

    activate(link) {
      const key = link.dataset.megaKey;
      this.panel.querySelectorAll('img[data-mega-key]').forEach((img) => {
        img.classList.toggle('active', img.dataset.megaKey === key);
      });

      if (this.follow) {
        if (this.caption) {
          this.caption.textContent = link.dataset.megaTitle || link.textContent.trim();
        }
        const href = link.getAttribute('href');
        this.ctas.forEach((cta) => {
          cta.setAttribute('href', href);
          cta.removeAttribute('aria-disabled');
          cta.removeAttribute('role');
        });
      }
    }
  }

  customElements.define('mega-menu-columns', MegaMenuColumns);
})();
